import { uuidv4 } from 'uuidv7';

export const VOICE_ID_PREFIX = 'VOICE';

export const generatePrettyId = (prefix: string) => {
  return `${prefix}-${uuidv4().substring(0, 8).toUpperCase()}`;
};

export const stripIdPrefix = (id: string, prefix: string): string => {
  if (id.startsWith(`${prefix}-`)) {
    return id.slice(`${prefix}-`.length);
  }
  return id;
};

export const generateFunctionId = () => generatePrettyId('FUNCTION');
export const generateTransitionId = () => generatePrettyId('TRANSITION');
export const generateParameterId = () => generatePrettyId('PARAMETER');
export const generateDelayResponseId = () => generatePrettyId('DELAY-RESPONSE');
export const generateStepId = () => generatePrettyId('STEP');
export const generateFunctionStepId = () => generatePrettyId('FUNC-STEP');
export const generateNoCodeStepId = () => generatePrettyId('NO-CODE-STEP');
export const generateConditionId = () => generatePrettyId('CONDITION');
export const generateFlowId = () => generatePrettyId('FLOW');
export const generateTopicId = () => generatePrettyId('TOPIC');
export const generateAttributeId = () => generatePrettyId('ATTRIBUTE');
export const generateVariantId = () => generatePrettyId('VARIANT');
export const generateStopKeywordId = () => generatePrettyId('STOP-KEYWORD');
export const generateSmsTemplateId = () => generatePrettyId('SMS-TEMPLATE');
export const generateTranscriptCorrectionId = () =>
  generatePrettyId('TRANSCRIPT-CORRECTION');
export const generateRegexId = () => generatePrettyId('REGEX');
export const generateDeployedVoiceId = () => generatePrettyId(VOICE_ID_PREFIX);
export const generateHandoffId = () => generatePrettyId('HANDOFF');
export const generateEntityId = () => generatePrettyId('ENTITY');
export const generateVariableId = () => generatePrettyId('VARIABLE');
export const generateApiIntegrationId = () =>
  generatePrettyId('API-INTEGRATION');
export const generateTranslationId = () => generatePrettyId('TRANSLATION');
